import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DocVertLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M12.5 3.5v3.6c0 .84 0 1.26.164 1.581a1.5 1.5 0 0 0 .655.656c.32.163.74.163 1.581.163h3.6m-.703-1.703-3.594-3.594c-.26-.26-.39-.39-.54-.482a1.5 1.5 0 0 0-.434-.18c-.173-.041-.356-.041-.723-.041H7.9c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656c-.163.32-.163.74-.163 1.581v12.2c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.656c.32.163.74.163 1.581.163h8.2c.84 0 1.26 0 1.581-.163a1.5 1.5 0 0 0 .656-.656c.163-.32.163-.74.163-1.581V9.494c0-.367 0-.55-.041-.723a1.5 1.5 0 0 0-.18-.433c-.093-.152-.223-.282-.482-.54Z" })));
}
const DocVertLightCustom = forwardRef(_DocVertLightCustom);
export { DocVertLightCustom };
